<template>
  <div class="login">
    <div class="contents">
      <div class="login-base">
        <login-title :type.sync="showType" typeName1="手机注册" typeName2="邮箱注册"/>
        <user-register-by-phone v-if="showType==1" />
        <user-register-by-mail v-if="showType==2" />
      </div>
    </div>
  </div>
</template>

<script>
import LoginTitle from '../components/user/LoginTitle.vue';
import UserRegisterByMail from '../components/user/UserRegisterByMail.vue';
import UserRegisterByPhone from '../components/user/UserRegisterByPhone.vue';
export default {
  components: {  LoginTitle,  UserRegisterByMail,UserRegisterByPhone },
  data(){
    return {
      showType:1
    }
  },
  metaInfo() {
    return {
      title: "Movibot官网",
      meta: [
        { name: "keywords", content: "Movibot官网" },
        { name: "description", content: "欢迎注册Movibot网站" },
      ],
    };
  },
};
</script>
<style  scoped>
.login {
  position: relative;
  width: 100%;
  height: 750px;
  background: url("/static/login/loginbj.png") no-repeat center top;
}
.login-base {
  position: absolute;
  right: 0;
  top: 170px;
  width: 380px;
}
.contents{
  margin: 0 auto;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/register.vue